"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _getPrototypeOf3 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _get2 = _interopRequireDefault(require("@babel/runtime/helpers/get"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _field = _interopRequireDefault(require("./field"));

var BooleanField =
/*#__PURE__*/
function (_Field) {
  (0, _inherits2.default)(BooleanField, _Field);

  function BooleanField() {
    var _getPrototypeOf2;

    var _this;

    (0, _classCallCheck2.default)(this, BooleanField);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = (0, _possibleConstructorReturn2.default)(this, (_getPrototypeOf2 = (0, _getPrototypeOf3.default)(BooleanField)).call.apply(_getPrototypeOf2, [this].concat(args)));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "_className", 'BooleanField');
    return _this;
  }

  (0, _createClass2.default)(BooleanField, [{
    key: "_create",
    value: function _create(props) {
      (0, _get2.default)((0, _getPrototypeOf3.default)(BooleanField.prototype), "_create", this).call(this, props);
      this.set({
        schema: {
          component: 'Form',
          fields: [{
            // Hide from docs as required doesn't make sense for a BooleanField
            name: 'required',
            docLevel: null
          }]
        }
      });
    }
  }, {
    key: "validate",
    value: function validate() {
      (0, _get2.default)((0, _getPrototypeOf3.default)(BooleanField.prototype), "validate", this).call(this);

      if (!this.isBlank()) {
        var value = this.getValue();

        if (value !== false && value !== true) {
          this.setErr('must be true or false');
        }
      }
    }
  }, {
    key: "getDisplayValue",
    value: function getDisplayValue() {
      var value = this.get('value');
      return value ? 'Yes' : 'No';
    }
  }, {
    key: "_setRequired",
    value: function _setRequired()
    /* required */
    {// Do nothing as we don't want to report any errors as this prop doesn't apply
    }
  }]);
  return BooleanField;
}(_field.default);

exports.default = BooleanField;